module.exports = __webpack_public_path__ + "static/img/1.7900ad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/1.png
// module id = W+47
// module chunks = 0